import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Spin, Button } from 'antd'
import {
  loadOutletRegisters,
  loadRegOutletsLoading,
  loadSelectedOutletRegisters,
  loadSelectedStoreOutlets
} from '../../appRedux/actions/Sell'
import { loadIsSelectReg } from '../../appRedux/actions/CommonData'
import IntlMessages from '../../util/IntlMessages'

const SidebarOutletsRegisters = () => {
  const dispatch = useDispatch()

  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  )
  const getReduxSelectedOutletReg = useSelector(
    ({ Sell }) => Sell.openCloseSelectedOutletReg
  )
  const getReduxRegOutLoading = useSelector(
    ({ Sell }) => Sell.openCloseRegOutletsLoading
  )
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)

  const [getSelectedOutlet, setSelectedOutlet] = React.useState({})
  const [getSelectedReg, setSelectedReg] = React.useState({})

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      let selectedLocalOut = localStorage.getItem('selectedOut')
      let selectedLocalReg = localStorage.getItem('selectedReg')
      if (selectedLocalOut) {
        selectedLocalOut = JSON.parse(selectedLocalOut)
        if (selectedLocalOut.id) {
          let body = {
            OutletID: selectedLocalOut.id
          }
          dispatch(loadRegOutletsLoading(true))
          dispatch(loadOutletRegisters(body, isOnline))
        }
        setSelectedOutlet(selectedLocalOut)
        dispatch(loadSelectedStoreOutlets(selectedLocalOut))
      }
      if (selectedLocalReg) {
        selectedLocalReg = JSON.parse(selectedLocalReg)
        setSelectedReg(selectedLocalReg)
        dispatch(loadSelectedOutletRegisters(selectedLocalReg))
      }
    }

    return () => (mounted = false)
  }, [isOnline])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      // let outlet = false;
      // let reg = false;
      if (getReduxSelectedStoreOutlets && getReduxSelectedStoreOutlets.id) {
        setSelectedOutlet(getReduxSelectedStoreOutlets)
        // setOutletName(
        //   getReduxSelectedStoreOutlets && getReduxSelectedStoreOutlets.outlet
        //     ? getReduxSelectedStoreOutlets.outlet
        //     : ""
        // );
        // outlet = getReduxSelectedStoreOutlets.id;
      } else {
        let selectedLocalOut = localStorage.getItem('selectedOut')
        if (selectedLocalOut) {
          selectedLocalOut = JSON.parse(selectedLocalOut)
          setSelectedOutlet(selectedLocalOut ? selectedLocalOut : {})
          // setOutletName(
          //   selectedLocalOut && selectedLocalOut.outlet
          //     ? selectedLocalOut.outlet
          //     : ""
          // );
          // outlet = getReduxSelectedStoreOutlets.id
          //   ? getReduxSelectedStoreOutlets.id
          //   : selectedLocalOut.id;
        } else {
          setSelectedOutlet({})
        }
      }

      if (getReduxSelectedOutletReg && getReduxSelectedOutletReg.id) {
        setSelectedReg(getReduxSelectedOutletReg)
        // reg = getReduxSelectedOutletReg && getReduxSelectedOutletReg.id
        //   ? getReduxSelectedOutletReg.id
        //   : "";
      } else {
        let selectedReg = localStorage.getItem('selectedReg')
        if (selectedReg) {
          selectedReg = JSON.parse(selectedReg)
          setSelectedReg(selectedReg)
          // reg = getReduxSelectedOutletReg.id
          //   ? getReduxSelectedOutletReg.id
          //   : selectedReg.id;
        } else {
          setSelectedReg({})
        }
      }

      // if (!outlet || !reg) {
      //   dispatch(loadIsSelectReg(true));
      // }

      return () => (mounted = false)
    }
  }, [getReduxSelectedStoreOutlets, getReduxSelectedOutletReg])

  return (
    <>
      <Spin
        // tip={<IntlMessages id="sell.cashlisting.loadcash" />}
        spinning={getReduxRegOutLoading}
        size='large'
      >
        <div className='dk-side-bar-content-switch sidebar-MainOutlet-div'>
          <p className='dk-switch-p'>
            {getReduxSelectedStoreOutlets && getReduxSelectedStoreOutlets.outlet
              ? getReduxSelectedStoreOutlets.outlet
              : getSelectedOutlet && getSelectedOutlet.outlet
              ? getSelectedOutlet.outlet
              : 'Please Select Outlet'}
          </p>
          <p className='dk-switch-p'>
            {getReduxSelectedOutletReg && getReduxSelectedOutletReg.register
              ? getReduxSelectedOutletReg.register
              : getSelectedReg && getSelectedReg.register
              ? getSelectedReg.register
              : 'Please Select Register'}
          </p>
          {isOnline && (
            <Button
              className='dk-btn-search sidebar-btn-div'
              size='small'
              onClick={() => dispatch(loadIsSelectReg(true))}
            >
              {getReduxSelectedOutletReg &&
              getReduxSelectedOutletReg.register ? (
                <IntlMessages id='reg.opendialog.switch' />
              ) : getSelectedReg && getSelectedReg.register ? (
                <IntlMessages id='reg.opendialog.switch' />
              ) : (
                <IntlMessages id='reg.opendialog.sel' />
              )}
            </Button>
          )}
        </div>

        {/* <div className="gx-flex-row gx-align-items-center gx-mb-4 gx-avatar-row">
          <Popover
            placement="bottomRight"
            content={outletOptions}
            // trigger="hover"
            visible={getIsOutletPopUp}
          >
            <BankFilled
              style={{ fontSize: "x-large" }}
              className="gx-size-40 gx-pointer gx-mr-3"
            />
            <span
              onClick={() => setIsOutletPopUp(!getIsOutletPopUp)}
              className="gx-avatar-name"
            >
              <strong>
                {getReduxSelectedStoreOutlets &&
                getReduxSelectedStoreOutlets.outlet
                  ? getReduxSelectedStoreOutlets.outlet
                  : getSelectedOutlet && getSelectedOutlet.outlet
                  ? getSelectedOutlet.outlet
                  : "Please Select Outlet"}
              </strong>
              <i className="icon icon-chevron-down gx-fs-xxs gx-ml-2" />
            </span>
          </Popover>
        </div>

        <div className="gx-flex-row gx-align-items-center gx-mb-4 gx-avatar-row">
          <Popover
            placement="bottomRight"
            content={regOptions}
            visible={getIsRegPopUp}
            // trigger="click"
          >
            <SnippetsFilled
              style={{ fontSize: "x-large" }}
              className="gx-size-40 gx-pointer gx-mr-3"
            />
            <span
              onClick={() => setIsRegPopUp(!getIsRegPopUp)}
              className="gx-avatar-name"
            >
              <strong>
                {getReduxSelectedOutletReg && getReduxSelectedOutletReg.register
                  ? getReduxSelectedOutletReg.register
                  : getSelectedReg && getSelectedReg.register
                  ? getSelectedReg.register
                  : "Please Select Register"}
              </strong>
              <i className="icon icon-chevron-down gx-fs-xxs gx-ml-2" />
            </span>
          </Popover>
        </div> */}
      </Spin>
    </>
  )
}

export default SidebarOutletsRegisters
